// these routes are exempt from redirecting to the Paywall even if the user has no subscription
export const REDIRECT_EXEMPT_ARTIST_PATHS = [
  '/artists/create-personal',
  '/profile/:profileId/subscriptions',
  '/profile/verify-age',
  '/profile/create',
  '/profile/create/:profileId',
  '/default',
  '/default-redirect',
  '/maintenance',
  '/public-profile/:guid',
  '/verify-email',
  '/login',
  '/',
];
